var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-mobile-guide mobile-guide"},[_c(_vm.defineComponent,{tag:"component",on:{"onStart":function($event){return _vm.handleComponents('proceed')},"onClose":function($event){return _vm.handleComponents('start')},"resetGuideShow":function (event) { return _vm.isResetGuideShow = event; }}}),_c('div',{class:[
            'o-mobile-guide__back-button-wrapper',
            {'start': _vm.currentUnit === 'start'},
            {'proceedWithResetButton': _vm.currentUnit === 'proceed' && _vm.isResetGuideShow}
        ]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }